<script setup>
import { ElPopover } from "element-plus";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const isReportActive = computed(
  () => route.name === "reports" || route.name === "Leaderboard"
);

const routes = computed(() => {
  return [
    {
      name: "Assignment History",
      to: "/reports?tab=assignment-history",
      urlType: "lms",
    },
    {
      name: "User Progress",
      to: "/reports?tab=course-overview",
      urlType: "lms",
    },
    {
      name: "Leaderboards",
      to: "/leaderboard",
      urlType: "lms",
    },
  ];
});
</script>
<template>
  <div v-bind="$attrs">
    <el-popover
      :width="230"
      popper-style="padding: 5px !important;z-index: 3000 !important; background-color: rgb(0 44 115)"
    >
      <template #reference>
        <a
          class="px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium cursor-pointer"
          :class="{
            'text-white border-white border-b-2': isReportActive,
            'hover:border-white border-b-2 border-transparent hover:text-white text-untitled-gray-400':
              !isReportActive,
          }"
        >
          Reports
        </a>
      </template>
      <template #default>
        <div class="w-full flex flex-col justify-start items-start">
          <div class="w-full" v-for="(r, index) in routes" :key="index">
            <router-link
              class="w-full px-2 py-2 text-sm flex justify-start items-start break-all break-after-all"
              :class="{
                'text-white': route.fullPath === r.to,
                'hover:text-white text-untitled-gray-400':
                  route.fullPath !== r.to,
              }"
              :to="r.to"
            >
              {{ r.name }}
            </router-link>
          </div>
        </div>
      </template>
    </el-popover>
  </div>
</template>
<style lang="scss" scoped></style>
